import { Box } from '@cdl/heartbeat-react';
import React, { PropsWithChildren, useRef } from 'react';
import { PageContext } from '../hooks/useHeaderRef';
import { Header } from './Header';

export const HEADER_HEIGHT = '3.125rem';

export const Page: React.FC<PropsWithChildren> = ({ children }) => {
  const headerRef = useRef<HTMLDivElement>(null);

  return (
    <Box display='flex' flexDirection='column'>
      <Header height={HEADER_HEIGHT} ref={headerRef} />
      <PageContext.Provider value={headerRef}>
        <Box display='flex' flexDirection='row' mt={HEADER_HEIGHT}>
          {children}
        </Box>
      </PageContext.Provider>
    </Box>
  );
};
